<template>
  <div>
    <b-container fluid>
      <!--<m-payment-brief></m-payment-brief>-->
      <b-row>
        <b-col class="top-col">
          <h1 class="top-h1">Review Count & Order</h1>
          <p>Complete the fields below to place your order.</p>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col lg="4" xl="4" md="4" class="left-title">
          <h3 class="order-summary-title">Payment Information</h3>
        </b-col>
        <b-col lg="4" xl="4" md="4" class="right-select"> </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col align-self="center" xl="8" lg="8" md="8" sm="12">
          <m-payment></m-payment>
          <m-check-terms></m-check-terms>
        </b-col>
      </b-row>
      <b-row class="bottom-btn top-col">
        <b-col>
          <b-btn
            variant="primary"
            class="placeorder-btn"
            @click="placeOrder"
            :disabled="!enablePlaceOrder"
            data-test="summary-placeOrder"
            >PLACE ORDER</b-btn
          >
        </b-col>
      </b-row>
      <b-row class="bottom-btn top-col">
        <b-col>
          <b-btn @click="goBack">
            <icon name="arrow-left" class="btn-arrow" /> BACK</b-btn
          >
          <b-btn v-b-modal.saveorder>SAVE LIST</b-btn>
          <b-btn @click="showSendQuote" v-if="isShowSenderQuote"
            >SEND QUOTE</b-btn
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MSummaryInfo from "@/components/summary/MSummaryInfo";
import MListUsage from "@/components/summary/MListUsage";
import MTargetArea from "@/components/summary/MTargetArea";
import MTargetAudience from "@/components/summary/MTargetAudience";
import MMediaTypeInfo from "@/components/summary/MMediaTypeInfo";
import MContactInformation from "@/components/summary/MContactInformation";
import MPayment from "@/components/summary/MPayment";
import MCheckTerms from "@/components/summary/MCheckTerms";
import MGeoGraphies from "@/components/summary/MGeoGraphies";
import notificaton from "@/components/common/notification";

import utlis from "@/assets/utils/index";
import MBox from "@/components/common/MBox";
import priceHelp from "@/assets/priceHelp.js";
import utils from "@/assets/utils";
import MOrderTotal from "@/components/summary/MOrderTotal";

export default {
  components: {
    MSummaryInfo,
    MListUsage,
    MTargetArea,
    MTargetAudience,
    MPayment,
    MCheckTerms,
    MContactInformation,
    MGeoGraphies,
    MBox,
    MMediaTypeInfo,
    MOrderTotal,
  },
  data() {
    return {
      enablePlaceOrderBtn: true,
    };
  },
  created() {
    if (
      process.env.NODE_ENV !== "production" &&
      this.$store.state.order.CurrentStep !== "summary"
    ) {
      this.$store.dispatch("order/getOrder", 111);
      this.$store.dispatch("order/getOrderContact");
    }
    window.testPrice = this.test;
  },
  methods: {
    test(order) {
      order = order || {};
      return priceHelp.updatePrice(order);
    },
    goBack() {
      window.history.go(-1)
    },
    goPayment() {
      // this.$router.go(-1);
    },
    showSaveOrder() {
      this.$root.$emit("bv::show::modal", "saveorder");
    },
    setContactinfo() {
      this.$store.commit("order/updateContactInformation", {
        key: "CountryCode",
        val: this.orderPayment.CountryCode,
      });
      this.$store.commit("order/updateContactInformation", {
        key: "State",
        val: this.orderPayment.State,
      });
      this.$store.commit("order/updateContactInformation", {
        key: "City",
        val: this.orderPayment.City,
      });
      this.$store.commit("order/updateContactInformation", {
        key: "AddressLine",
        val: this.orderPayment.AddressLine,
      });
      this.$store.commit("order/updateContactInformation", {
        key: "Zipcode",
        val: this.orderPayment.Zipcode,
      });
    },
    placeOrder() {
      if (
        this.$store.state.order.TotalDesiredQty < this.site.MinQuantityOfOrder
      ) {
        notificaton.notice(
          "error",
          "The quantity that you entered is less than the minimum quantity of " +
            this.site.MinQuantityOfOrder +
            ".",
          { title: "Total Number Error", onlyGroup: "CountNumberError" }
        );
        return;
      }
      if (this.validOrder()) {
        this.setContactinfo();
        if (this.$store.state.site.IsVertaxEnabled) {
          this.$root.$emit("bv::show::modal", "placeOrderTax");
        } else {
          this.enablePlaceOrderBtn = false;
          if (this.order.MediaTypeName === "facebook") {
            this.$store.commit("order/saveKey", ["TenantId", ""]);
            this.$store.commit("order/saveKey", ["DestinationId", ""]);
            this.$store.commit("order/saveKey", ["DestinationAccountId", ""]);
          } else if (this.order.MediaTypeName === "twitter") {
            this.$store.commit("order/saveKey", ["ShareAccountId", ""]);
            this.$store.commit("order/saveKey", ["PackageName", ""]);
          }
          this.$http
            .post("PlaceOrder.aspx/ProcessOrder", {
              currentSessionId: this.$store.state.site.CurrentSessionId,
              industry: "",
              licenseName: "",
              password: "",
              sanExpDate: "",
              sanNumber: "",
              order: this.order,
            })
            .then(
              (resp) => {
                this.enablePlaceOrderBtn = true;
                let data = resp.body.d.DataSource;
                if (!data.IsSuccess) {
                  notificaton.notice(
                    "error",
                    "Unfortunately, the system is unable to process your request. Our technical support specialists have been notified. Thank you for your patience while we work to resolve the error.",
                    { title: "Place Order Error", onlyGroup: "placeOrderError" }
                  );
                  return false;
                }

                this.$store.commit("order/saveKey", [
                  "OrderCode",
                  data.OrderCode,
                ]);
                this.$store.commit("order/saveKey", [
                  "AccountName",
                  data.AccountName,
                ]);
                this.$store.commit("order/saveKey", [
                  "SessionGuid",
                  data.OrderSessionGuid,
                ]);
                this.$store.commit("order/saveKey", [
                  "OrderSubmittedDate",
                  data.OrderSubmittedDate,
                ]);
                this.$store.commit("order/saveKey", ["CurrentStep", "success"]);

                utils.uaEcommerce(
                  this.$store.state.order,
                  this.$store.getters["config/datasource"].name,
                  this.$store.getters["config/datasource"].SKU
                );
                this.$router.push({ path: "success" });

                // update user point
                // TODO@PONY need to use new api
                this.$http.post("LandingPage.aspx/GetUserPoint", {}).then(
                  (resp) => {},
                  (resp) => {
                    this.$store.commit("user/saveKey", [
                      "userPoint",
                      resp.body.d.DataSource.UserPoint,
                    ]);
                  }
                );
              },
              (resp) => {
                this.enablePlaceOrderBtn = true;
              }
            );
        }
      }
    },
    showSendQuote() {
      this.$http
        .post("PlaceOrder.aspx/IsOrderQuoteAvailable", {
          order: this.$store.state.order,
        })
        .then(
          (resp) => {
            this.$root.$emit("bv::show::modal", "sendQuote");
          },
          (resp) => {
            notificaton.notice(
              "error",
              'In order to "send Quote", please first "Save Count"',
              {}
            );
          }
        );
    },
    validOrder() {
      let existError = false;

      // aggrement
      if (!this.$store.state.summary.aggreAgreement) existError = true;

      if (utlis.verify(this.orderContactInformation.OrderName, "require"))
        existError = true;
      if (
        utlis.verify(this.orderContactInformation.Email, ["require", "email"])
      )
        existError = true;
      if (utlis.verify(this.orderContactInformation.Company, "require"))
        existError = true;

      if (this.isCreditCard) {
        // need verify card type
        if (utlis.verify(this.orderPayment.HolderName, "require"))
          existError = true;
        if (utlis.verify(this.orderPayment.Number, ["require", "creditCard"]))
          existError = true;
        if (utlis.verify(this.orderPayment.SecurityCode, ["require"]))
          existError = true;
        // need verify card expiration
        // need verify country
        if (utlis.verify(this.orderPayment.AddressLine, ["require"]))
          existError = true;
        if (utlis.verify(this.orderPayment.City, ["require"]))
          existError = true;
        if (utlis.verify(this.orderPayment.State, ["require"]))
          existError = true;
        if (utlis.verify(this.orderPayment.Zipcode, ["require", "zip"]))
          existError = true;
      }
      if (this.order.ListType === 270) {
        if (utlis.verify(this.order.MediaTypeName, ["require"]))
          existError = true;
      }
      if (this.order.MediaTypeName === "facebook") {
        if (utlis.verify(this.order.ShareAccountId, ["require"]))
          existError = true;
        if (utlis.verify(this.order.PackageName, ["require"]))
          existError = true;
      } else if (this.order.MediaTypeName === "twitter") {
        if (utlis.verify(this.order.TenantId, ["require"])) existError = true;
        if (utlis.verify(this.order.DestinationId, ["require"]))
          existError = true;
        if (utlis.verify(this.order.DestinationAccountId, ["require"]))
          existError = true;
      }
      this.$store.commit("summary/saveShowError", existError);
      return !existError;
    },
  },
  computed: {
    site() {
      return this.$store.state.site;
    },
    orderContactInformation() {
      return this.$store.state.order.OrderContactInformation || {};
    },
    orderPayment() {
      return this.$store.state.order.OrderPaymentInformation || {};
    },
    isContactAddressComplete() {
      return this.$store.state.summary.IsContactAddressComplete || false;
    },
    isCreditCard() {
      return this.$store.getters["order/isCreditCard"];
    },
    isShowGeoGraphies() {
      return this.$store.state.order.ListType === 50;
    },
    enablePlaceOrder: {
      get: function () {
        return (
          this.$store.getters["site/enablePlaceOrder"] &&
          this.enablePlaceOrderBtn
        );
      },
      set: function (newValue) {
        this.enablePlaceOrderBtn = newValue;
      },
    },
    isShowSenderQuote() {
      return this.$store.state.site.IsOrderQuoteEnabled;
    },
    order() {
      return this.$store.state.order;
    },
  },
  mounted() {
    this.$root.$on("placeOrder", () => {
      this.placeOrder();
    });
  },
};
</script>

<style scoped lang="scss">
.row-placeorder {
  margin-top: 16px;
  display: block;
}

.bottom-btn {
  margin-top: 16px;
}
.right-zone {
  padding-left: 0px;
}
.top-btns {
  display: flex;
  margin-top: 16px;
}
.top-btn {
  margin-right: 8px;
}
.title-zone {
  text-align: center;
  margin-left: 80px;
}

.order-summary-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 0px;
}

@media (max-width: 768px) {
  .top-btns {
    flex-direction: column;
  }
  .top-btn {
    margin-top: 8px;
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/PaymentSummary.vue